import type { InputOtpDesignTokens } from '@primeuix/themes/types/inputotp';

export default {
    root: {
        gap: '0.5rem',
    },
    input: {
        width: '2.5rem',
        sm: {
            width: '2rem',
        },
        lg: {
            width: '3rem',
        },
    },
} satisfies InputOtpDesignTokens;
